import { observer } from 'mobx-react-lite';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  Button,
  Form,
  Header,
  Input,
  Segment,
  Select,
} from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import agent from '../../../../app/api/agent';
import { toast } from 'react-toastify';
import sendRespectiveEmail from '../../../../app/models/EmailNew';
import { User } from '../../../../app/models/user';

function OutwardAssignPickerForm() {
  const {
    dashboardStore,
    activityStore: {
      outward: { assignPickerDefault, assignPickerOutward },
      selectedActivity,
    },
    userStore,
    commonStore,
  } = useStore();
  const { userList, loadUsers } = userStore;
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [pickerEmail, setPickerEmail] = useState<string>('');
  const [picker, setPicker] = useState<string>('');
  const [userOptions, setUserOptions] = useState<
    { key: string; text: string; value: string }[]
  >([]);

  useEffect(() => {
    if (userList.length === 0) loadUsers();
  }, [userList.length, loadUsers]);

  useEffect(() => {
    if (assignPickerDefault.pickerName !== '' && userOptions.length > 0) {
      const tempPicker = userOptions?.filter(
        (eachUser) => eachUser.text === assignPickerDefault.pickerName,
      );
      setPicker(tempPicker[0]?.value);
    }
    if (assignPickerDefault.pickerPhoneNumber !== '') {
      setPhoneNumber(assignPickerDefault.pickerPhoneNumber);
    }
  }, [assignPickerDefault, userOptions]);

  useEffect(() => {
    const tempOptions = userStore.getUsers.map((x) => ({
      key: x.id,
      text: x.displayName,
      value: x.id,
    }));
    setUserOptions(tempOptions);
  }, [userStore.getUsers]);

  const getInfoById = (id: string, field: string) => {
    const user = userStore.getUsers?.filter((user) => user.id === id);
    switch (field) {
      case 'displayName':
        return user[0]?.displayName;
      default:
        return '';
    }
  };

  const handleChange = (e: SyntheticEvent, data: any) => {
    if (data.value === '') {
      setPhoneNumber('');
      setPicker('');
    } else {
      const userdata = userList.filter((u: User) => u.id === data.value)?.[0];
      if (userdata?.phoneNumber) {
        setPhoneNumber(
          userdata?.phoneNumber !== undefined ? userdata?.phoneNumber : '',
        );
        setPicker(userdata?.id !== undefined ? userdata?.id : '');
      } else {
        setPhoneNumber('');
        setPicker(userdata?.id !== undefined ? userdata?.id : '');
      }
      setPickerEmail(userdata?.email || '');
    }
  };

  const asignPickerHandler = async (payload: any) => {
    try {
      let result = await agent.Outwards.outwardPickerAssignUpdate(payload);
      if (result?.data.includes('assigned')) {
        commonStore.updateHistoryAlonePOST(
          `The asset ${selectedActivity?.title} is picked by ${payload.pickerName}`,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );

        await agent.InventoryDelivery.OrderTrackingStatus(
          selectedActivity?.id,
          'Outward Asset Picker Assigned',
        );
        sendRespectiveEmail(
          '',
          selectedActivity?.title || '',
          'outWard - Notification',
          '',
          '',
          pickerEmail,
          `Dear ${payload.pickerName}, <br/>\u00A0  ${selectedActivity?.title} {${selectedActivity?.id}} is assigned to you to pick it up for delivery. <br/> <br/> Regards, <br/> ${userStore.user?.displayName}`,
        );
      } else {
        commonStore.updateHistoryAlonePOST(
          result?.data,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
      }
      dashboardStore.dashboard.valueForL3Orders = 'Move';
    } catch {
      toast.error('Something went wrong');
    }
  };

  // submitting form

  const handleSubmit = async () => {
    // for Outward
    if (dashboardStore.dashboard.valueForL3Orders === 'AssignPickerOutward') {
      let payload: any = {};
      assignPickerOutward.data?.forEach((localData: any) => {
        if (localData.id === selectedActivity?.id) {
          payload = {
            id: localData.deliveryRequestId || '',
            pickerName: getInfoById(picker, 'displayName'),
            pickerPhoneNo: phoneNumber,
          };
        }
      });
      asignPickerHandler(payload);
      dashboardStore.dashboard.AssetTableAssignClicked = '';
      setPhoneNumber('');
    }
  };

  return (
    <Segment
      style={{
        height: '61.8vh',
        marginTop: '10px',
        marginBottom: '1px',
        overflowY: 'scroll',
        marginRight: '10px',
      }}
    >
      <Header
        icon="edit"
        size="huge"
        dividing
        as="h1"
        content="Authorized Personnal"
        sub
        color="grey"
      />
      <Header />
      <Header />
      {dashboardStore.dashboard.L2CardValueOrders === 'Outward' &&
      dashboardStore.dashboard.valueForL3Orders === 'AssignPickerOutward' &&
      dashboardStore.dashboard.AssetTableAssignClicked.length !== 0 ? (
        <>
          <Form>
            <Form.Field
              id="picker_name: "
              options={userOptions}
              control={Select}
              label="Picker Name"
              placeholder="Select Picker Name"
              clearable
              onChange={handleChange}
              value={picker}
            />
            <Form.Field
              id="picker_phone: "
              //options={options}
              control={Input}
              label="Picker Phone No "
              placeholder="Picker Phone No"
              value={phoneNumber}
              onChange={(_e: any, { value }: { value: string }) =>
                setPhoneNumber(value)
              }
            />

            <Form.Field id="ReelNumber" label="" placeholder="" />
          </Form>
          <Button.Group
            style={{
              position: 'absolute',
              bottom: '5px',
              left: '5px',
            }}
          >
            <Button>Cancel</Button>

            <Button.Or />

            <Button
              type="submit"
              content="Submit"
              positive
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Button.Group>
        </>
      ) : (
        <p style={{ marginTop: '-15px' }}>Please select item received</p>
      )}
    </Segment>
  );
}

export default observer(OutwardAssignPickerForm);
